module.exports = __webpack_public_path__ + "img/constract.63b9e99e.jpg";